/*-------------------------------------------*/
/*----------IMPORTS AND INITIALIZERS---------*/
/*-------------------------------------------*/

// Imports
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { 
    Button, Grid, Typography, Toolbar, 
    Dialog, DialogTitle, DialogContent, 
    DialogContentText, DialogActions, 
    Box, Drawer, Stack, IconButton 
} from '@mui/material';
import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

/*------------------------------------------*/
/*-----------------COMPONENT----------------*/
/*------------------------------------------*/

const Login = () => {

    /*--------------------*/
    /*-STATES AND METHODS-*/
    /*--------------------*/

    // Set page background color
    useEffect(() => {
        document.body.style.backgroundColor = 'white'
    }, [])

    // For navigating to other pages
    const navigate = useNavigate()

    // For tracking user inputs
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)

    // // Handling submit
    // const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        
    //     e.preventDefault()
    //     const url: string = `http://${process.env.REACT_APP_HOST_NAME}:${process.env.REACT_APP_SERVER_PORT}/${process.env.REACT_APP_LOGIN_ROUTE}?userName=${encodeURIComponent(userName)}&password=${encodeURIComponent(password)}`

    //     axios.get(url)
    //         .then(res => {

    //             // Login information validated successfully
    //             if (res.status === 200) {
    //                 console.log(`${userName} Logged in successfully.`)
    //                 const userData = {
    //                     username: userName,
    //                     password: password
    //                 }

    //                 window.localStorage.setItem(`${process.env.REACT_APP_USER_DATA}`, JSON.stringify(userData))
    //                 navigate('/Accounts')
    //             }
    //         })
    //         .catch(err => {

    //             // Server and faulty credentials error handling
    //             if (err.response) handleClickOpen()
    //             else if (err.request) console.log('No response received:', err.request)
    //             else console.log('Error:', err.message);
    //         })
    // };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        
        e.preventDefault()
        const url: string = `https://${process.env.REACT_APP_HOST_NAME}/${process.env.REACT_APP_LOGIN_ROUTE}`

        console.log(url)
        axios.post(url)
            .then(res => {

                console.log(JSON.stringify(res))
                // Login information validated successfully
                if (res.status === 200) {
                    // console.log(`${userName} Logged in successfully.`)
                    const userData = {
                        username: userName,
                        password: password
                    }

                    window.localStorage.setItem(`${process.env.REACT_APP_USER_DATA}`, JSON.stringify(userData))
                    navigate('/Accounts')
                }
            })
            .catch(err => {

                // Server and faulty credentials error handling
                if (err.response) handleClickOpen()
                else if (err.request) console.log('No response received:', err.request)
                else console.log('Error:', err.message);
            })
    };

    // For warning dialog window
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // For handling logo sidebar
    const logoSidebarWidth = 460

    const logoSidebar = (
        <Grid item sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            width: { sm: logoSidebarWidth },
            backgroundColor: 'black'
        }}>
            <img 
                src='movius-logo-digital-stacked-reversed.png' 
                alt='Logo' 
                style={{ width: '60%', objectFit: 'scale-down' }}
            />
        </Grid>
    )

    /*------------------------------------------*/
    /*-----------------COMPONENT----------------*/
    /*------------------------------------------*/

    return (
        <Box style={{ height: '100vh' }}>

            {/* Toggle warning dialog window */}
            {/* <Fragment>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"></DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            The username or password is incorrect.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Okay</Button>
                    </DialogActions>
                </Dialog>
            </Fragment> */}
        
            {/* Render drawer for screen sizes: xs: 'none', sm: 'none', md: 'block' */}
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', sm: 'none', md: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: logoSidebarWidth, bgcolor: '#1e1d31' },
                }}
                open
            >
                {logoSidebar}
            </Drawer>

            {/* Render login form container */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: '100vh',
                    backgroundImage: `url("movius-logo-digital-stacked-white-logo-only.png")`,
                    backgroundColor: '#fff5f4',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    ml: { md: `${logoSidebarWidth}px` }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column'        
                    }}
                >

                    {/* Page heading */}
                    <Typography component="h1" variant="h4" sx={{ fontWeight: 'bold' }}>
                        Welcome!
                    </Typography>
                    <Toolbar/>
                    <Typography component="h1" variant="h5" sx={{ mb: '20px'}}>
                        Login to your account here
                    </Typography>

                    {/* Render form */}
                    <form onSubmit={handleSubmit}>

                        {/* Form fields */}
                        <Stack spacing={2} direction='column'>
                            <Box>
                                <Form.Control
                                    id="userName"
                                    name="userName"
                                    onChange={(e) => setUserName(e.target.value)}
                                    placeholder='Username*'
                                    style={{ 
                                        backgroundColor: 'transparent', 
                                        border: '1px solid gray', 
                                        height: '40px' 
                                    }}
                                    // required
                                />
                            </Box>
                            <Box>
                                <InputGroup>
                                    <Form.Control
                                        id="password"
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder='Password*'
                                        style={{ 
                                            backgroundColor: 'transparent', 
                                            border: '1px solid gray', 
                                            borderRight: 'none',
                                            height: '40px'
                                        }}
                                        // required
                                    />
                                    <IconButton 
                                        onClick={() => setShowPassword(!showPassword)} 
                                        style={{ 
                                            backgroundColor: 'transparent',
                                            border: '1px solid gray',
                                            borderTopRightRadius: '7px', 
                                            borderBottomRightRadius: '7px',
                                            borderLeft: 'none',
                                            height: '40px'
                                        }}
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputGroup>
                            </Box>
                        </Stack>

                        {/* Submit button */}
                        <Box>
                            <Button
                                type='submit'
                                variant='contained'
                                fullWidth
                                sx={{ 
                                    mt: 3, 
                                    mb: 2, 
                                    borderRadius: '20px', 
                                    backgroundColor: 'black',
                                    '&:hover': {
                                        backgroundColor: '#3b3b3b'
                                    }
                                }}
                            >Login</Button>
                        </Box>
                        
                    </form>

                </Box>
            </Box>
        </Box>
    );
}

export default Login